// //Here is the compatible package for this particles- npm install tsparticles@2.12.0 react-tsparticles@2.12.0

// import Particles from 'react-tsparticles';
// import { loadFull } from 'tsparticles'; // Using loadFull instead of loadSlim

// const ParticlesBackground = () => {
//   const particlesInit = async (engine) => {
//     await loadFull(engine);
//   };

//   return (
//     <Particles
//       id="tsparticles"
//       init={particlesInit}
//       options={{
//         fullScreen: {
//           enable: true,
//           zIndex: -1
//         },
//         particles: {
//           number: {
//             value: 80,
//             density: {
//               enable: true,
//               value_area: 800
//             }
//           },
//           color: {
//             value: "#ffffff"
//           },
//           shape: {
//             type: "circle"
//           },
//           opacity: {
//             value: 0.5,
//             random: true
//           },
//           size: {
//             value: 3,
//             random: true
//           },
//           links: {
//             enable: true,
//             distance: 150,
//             color: "#ffffff",
//             opacity: 0.4,
//             width: 1
//           },
//           move: {
//             enable: true,
//             speed: 2,
//             direction: "none",
//             random: false,
//             straight: false,
//             outModes: {
//               default: "out"
//             }
//           }
//         },
//         interactivity: {
//           events: {
//             onHover: {
//               enable: true,
//               mode: "repulse"
//             },
//             onClick: {
//               enable: true,
//               mode: "push"
//             }
//           },
//           modes: {
//             repulse: {
//               distance: 100,
//               duration: 0.4
//             },
//             push: {
//               quantity: 4
//             }
//           }
//         },
//         detectRetina: true
//       }}
//     />
//   );
// };

// export default ParticlesBackground;


// import Particles from 'react-tsparticles';
// import { loadFull } from 'tsparticles';

// const ParticlesBackground = () => {
//   const particlesInit = async (engine) => {
//     await loadFull(engine);
//   };

//   return (
//     <Particles
//       id="tsparticles"
//       init={particlesInit}
//       options={{
//         fullScreen: {
//           enable: true,
//           zIndex: -1
//         },
//         particles: {
//           number: {
//             value: 30,
//             density: {
//               enable: true,
//               value_area: 800
//             }
//           },
//           color: {
//             value: "#FFD700" 
//           },
//           shape: {
//             type: "image",
//             images: [
//               {
//                 src: "https://cdn-icons-png.flaticon.com/512/272/272525.png", // Coin image
//                 width: 50,
//                 height: 50
//               },
//             //   {
//             //     // src: "https://cdn-icons-png.flaticon.com/512/477/477406.png", // Dollar bill image
//             //      src: "https://cdn-icons-png.flaticon.com/512/10535/10535983.png", // Dollar bill image
//             //     width: 50,
//             //     height: 50
//             //   },
//             //   {
//             //     src: "https://cdn-icons-png.flaticon.com/512/679/679922.png", // Product box
//             //     width: 40,
//             //     height: 40,
//             //     replaceColor: true
//             //   }
//             ]
//           },
//           opacity: {
//             value: 0.8,
//             random: true
//           },
//           size: {
//             value: 20, 
//             random: true
//           },
//           links: {
//             enable: false 
//           },
//           move: {
//             enable: true,
//             speed: 2, 
//             direction: "none",
//             random: true,
//             straight: false,
//             outModes: {
//               default: "bounce" 
//             },
//             rotate: {
//               value: {
//                 min: 0,
//                 max: 360
//               },
//               animation: {
//                 enable: true,
//                 speed: 5,
//                 sync: false
//               }
//             }
//           }
//         },
//         interactivity: {
//           events: {
//             onHover: {
//               enable: true,
//               mode: "grab"
//             },
//             onClick: {
//               enable: true,
//               mode: "repulse"
//             }
//           },
//           modes: {
//             grab: {
//               distance: 100,
//               links: {
//                 opacity: 0.5
//               }
//             },
//             repulse: {
//               distance: 100,
//               duration: 0.4
//             }
//           }
//         },
//         detectRetina: true
//       }}
//     />
//   );
// };

// export default ParticlesBackground;


import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';

const ParticlesBackground = () => {
    const particlesInit = async (engine) => {
        await loadFull(engine);
    };

    return (
        <Particles
            id="tsparticles"
            init={particlesInit}
            options={{
                fullScreen: {
                    enable: true,
                    zIndex: -1
                },
                particles: {
                    number: {
                        value: 30,
                        density: {
                            enable: true,
                            value_area: 800
                        }
                    },
                    color: {
                        value: "#FFD700"
                    },
                    shape: {
                        type: "image",
                        images: [
                            {
                                src: "https://cdn-icons-png.flaticon.com/512/272/272525.png",
                                width: 50,
                                height: 50
                            },
                            
                        ]
                    },
                    opacity: {
                        value: 0.8,
                        random: true
                    },
                    size: {
                        value: 20,
                        random: true
                    },
                    links: {
                        enable: false
                    },
                    move: {
                        enable: true,
                        speed: 2,
                        direction: "none",
                        random: true,
                        straight: false,
                        outModes: {
                            default: "bounce"
                        }
                    },
                    rotate: {
                        value: 0,
                        animation: {
                            enable: true,
                            speed: 55, // Faster spin speed
                            sync: false, // Each coin spins independently
                            startValue: "random", // Start at random rotation angles
                            destroy: "none"
                        }
                    },
                    wobble: {
                        distance: 10,
                        speed: 3
                    }
                },
                interactivity: {
                    events: {
                        onHover: {
                            enable: true,
                            mode: "grab",
                            parallax: {
                                enable: true,
                                force: 20,
                                smooth: 10
                            }
                        },
                        onClick: {
                            enable: true,
                            mode: "repulse"
                        }
                    },
                    modes: {
                        grab: {
                            distance: 100,
                            links: {
                                opacity: 0.5
                            }
                        },
                        repulse: {
                            distance: 100,
                            duration: 0.4
                        }
                    }
                },
                detectRetina: true,
                motion: {
                    reduce: {
                        factor: 3
                    }
                }
            }}
        />
    );
};

export default ParticlesBackground;